module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "raised": !_vm.address.default
    }
  }, [_c('v-card-text', [_c('strong', [_vm._v(_vm._s(_vm.address.first_name) + " " + _vm._s(_vm.address.last_name)), _c('br')]), _vm._v("\n      " + _vm._s(_vm.address.street1)), _c('br'), _vm._v(" "), (_vm.street2) ? [_vm._v(_vm._s(_vm.address.street2)), _c('br')] : _vm._e(), _vm._v("\n      " + _vm._s(_vm.address.city) + ", " + _vm._s(_vm.address.state) + " " + _vm._s(_vm.address.zip) + "\n    ")], 2), _vm._v(" "), _c('v-card-actions', [(_vm.address.validated) ? _c('v-icon', [_vm._v("mdi-map-marker-check")]) : _vm._e(), _vm._v(" "), (_vm.address.default) ? _c('v-icon', [_vm._v("mdi-bookmark")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('edit', _vm.address)
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('delete', _vm.address.id)
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88d44338","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/shipping-address.vue
// module id = 700
// module chunks = 1